import type { AcademicTerm } from '../types/domain';
import { heuristicTermNumberFromMonth, inferKoreanSchoolAcademicYear } from './dashboardTermResolve';
import { parseISODate } from './date';

/** 주간학습안내·연간진도표와 같이 academic_terms에서 dateIso가 속한 학기 */
export function resolveTermNumberForViewDate(terms: AcademicTerm[], dateIso: string): 1 | 2 {
  const iso = (dateIso ?? '').trim();
  if (iso) {
    for (const n of [1, 2] as const) {
      const t = terms.find((row) => row.term_number === n);
      if (!t) continue;
      if (iso >= t.starts_on && iso <= t.ends_on) return n;
    }
  }
  const parsed = parseISODate(iso);
  const d = !Number.isNaN(parsed.getTime()) ? parsed : new Date();
  return heuristicTermNumberFromMonth(d);
}

export function inferAcademicYearForViewDate(dateIso: string): number {
  const parsed = parseISODate((dateIso ?? '').trim());
  if (!Number.isNaN(parsed.getTime())) return inferKoreanSchoolAcademicYear(parsed);
  return inferKoreanSchoolAcademicYear(new Date());
}
